import { createContext, useContext } from 'react';
import { User } from 'types/api/users.type';

export type ContextType = {
  isShippingAddress: boolean;
  isShippingAddressSet: (arg: boolean) => void;
  user?: User;
  userSet?: (user: User) => void;
  form: any; // eslint-disable-line
  onSubmit: () => void;
  userIdToRestore?: string;
  userIdToRestoreSet?: (id: string) => void;
};

export const UsersContext = createContext<ContextType>({
  isShippingAddress: false,
  isShippingAddressSet: () => null,
  user: undefined,
  form: undefined,
  onSubmit: () => null,
  userSet: () => null,
  userIdToRestore: '',
  userIdToRestoreSet: () => null,
});

export const useUsersContext = () => useContext(UsersContext);
